<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="edit-outline" *ngIf="action === 'edit'"></nb-icon>
        <nb-icon icon="plus-outline" *ngIf="action !== 'edit'"></nb-icon>
        <div class="ml-2" *ngIf="action === 'edit'" i18n>Editing Content: {{ content.content_id }}</div>
        <div class="ml-2" *ngIf="action === 'clone'" i18n>Cloning Content</div>
        <div class="ml-2" *ngIf="action === 'create'" i18n>Creating Content</div>
      </div>
      <div class="d-flex flex-row align-items-center">
        <button
          nbButton
          class="ml-3"
          outline
          [disabled]="disableRefreshButton"
          status="info"
          shape="round"
          size="small"
          (click)="refresh()"
          nbTooltip="Refresh DRB IDs"
          i18n-nbTooltip
        >
          <nb-icon icon="refresh-outline"></nb-icon>
        </button>
        <button nbButton class="ml-3" (click)="close()">
          <nb-icon icon="close-outline"></nb-icon>
        </button>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <!-- Those are general Content fields that are same for any type of payloard record [banner, MS, Contextual] -->
    <strong class="text-uppercase" i18n>Content Details</strong>
    <hr />
    <form #contentForm="ngForm">
      <div class="row">
        <div class="col-4">
          <div i18n>Category Icon ID<span style="color: red">*</span>:</div>
        </div>
        <div class="col-8">
          <div class="d-flex align-items-center">
            <nb-select
              placeholder="Category Icon ID"
              i18n-placeholder
              [(ngModel)]="content.category_icon_id"
              fullWidth
              style="width: 90%"
              id="category_icon_id.id"
              name="content.category_icon_id"
              ngControl="categoryCtrl"
              required
              (selectedChange)="onSelectionChange($event)"
            >
              <nb-option *ngFor="let category of categoryIconId" [value]="category">
                {{ category | replaceunderscore | titlecase }}
              </nb-option>
            </nb-select>
            <nb-icon
              class="ml-2"
              icon="info-outline"
              nbTooltip="Icon displayed in the notification summary item."
              i18n-nbTooltip
            ></nb-icon>
          </div>
        </div>
      </div>
      <br />

      <div class="row">
        <div class="col-4">
          <div i18n>Category Title Text:</div>
        </div>
        <div class="col-8">
          <div class="d-flex align-items-center">
            <nb-select
              placeholder="Category Title"
              i18n-placeholder
              [(ngModel)]="content.category_title_text"
              fullWidth
              style="width: 90%"
              id="category_title_text"
              name="category_title_text"
              ngControl="categoryCtrl"
              #category_title_text="ngModel"
              (selectedChange)="onCategoryTitleSelect($event)"
            >
              <nb-option *ngFor="let category of availableCategories()" [value]="category.text">
                {{ category.text | replaceunderscore | titlecase }}
              </nb-option>
            </nb-select>
            <nb-icon
              class="ml-2"
              icon="info-outline"
              nbTooltip="Title text shown in the notification summary item. Text is displayed if present, otherwise the Category Title ID is looked at to display the text."
              i18n-nbTooltip
            ></nb-icon>
          </div>
        </div>
      </div>
      <br />

      <div class="row">
        <div class="col-4"><div i18n>Category Title ID:</div></div>
        <div class="col-8">
          <input
            nbInput
            placeholder="Category Title ID"
            i18n-placeholder
            [(ngModel)]="content.category_title_id"
            fullWidth
            style="width: 90%"
            id="category_title_id"
            name="category_title_id"
            ngControl="categoryCtrl"
            #category_title_id="ngModel"
            disabled
          />
        </div>
      </div>
      <br />

      <div class="row">
        <div class="col-4">
          <div i18n>Action Type<span style="color: red">*</span>:</div>
        </div>
        <div class="col-8">
          <div class="d-flex align-items-center">
            <nb-select
              placeholder="Action Type"
              i18n-placeholder
              [(ngModel)]="content.action_type"
              fullWidth
              style="width: 90%"
              id="content.action_type"
              name="content.action_type"
              ngControl="categoryCtrl"
              required
              (ngModelChange)="onActionTypeChange()"
            >
              <nb-option *ngFor="let action of actionType" [value]="action">
                {{ action | replaceunderscore | titlecase }}
              </nb-option>
            </nb-select>
            <nb-icon
              class="ml-2"
              icon="info-outline"
              nbTooltip="Is optional, present only when special processing is needed by the app to handle it. The default value of 'content' means the application should just display the standard payload fields in order they are received."
              i18n-nbTooltip
            ></nb-icon>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-4">
          <div i18n>Display Type<span style="color: red">*</span>:</div>
        </div>
        <div class="col-8">
          <div class="d-flex align-items-center">
            <nb-select
              placeholder="Display Type"
              i18n-placeholder
              [(ngModel)]="content.display_type"
              fullWidth
              style="width: 90%"
              id="content.display_type"
              name="content.display_type"
              ngControl="categoryCtrl"
              required
            >
              <nb-option *ngFor="let display of displayType" [value]="display">
                {{ display | replaceunderscore | titlecase }}
              </nb-option>
            </nb-select>
            <nb-icon
              class="ml-2"
              icon="info-outline"
              nbTooltip="Determines how the action content is displayed when the Notification Summary is selected."
              i18n-nbTooltip
            ></nb-icon>
          </div>
        </div>
      </div>
      <br />

      <div class="row">
        <div class="col-4">
          <div i18n>Min App Version<span style="color: red">*</span></div>
        </div>
        <div class="col-8">
          <div class="d-flex align-items-center">
            <ng-select
              placeholder="Min App Version"
              i18n-placeholder
              [(ngModel)]="content.min_app_version"
              fullWidth
              style="width: 90%"
              id="min_app_version"
              name="min_app_version"
              ngControl="categoryCtrl"
              [groupBy]="groupByFn"
              required
              (change)="togglePrime($event)"
            >
              <ng-option *ngFor="let version of versions" [value]="version">
                {{ version }}
              </ng-option>
            </ng-select>
            <nb-icon
              class="ml-2"
              icon="info-outline"
              nbTooltip="Minimum app version that can recieve this content. Some features are only supported from certain versions onward."
              i18n-nbTooltip
            ></nb-icon>
          </div>
        </div>
      </div>
      <br />

      <div class="row">
        <div class="col-4">
          <div i18n>Headline Text:</div>
        </div>
        <div class="col-8">
          <div class="d-flex align-items-center">
            <input
              nbInput
              placeholder="Headline Text"
              i18n-placeholder
              [(ngModel)]="content.headline_text"
              fullWidth
              style="width: 90%"
              id="headline_text"
              name="headline_text"
              ngControl="categoryCtrl"
            />
            <nb-icon
              class="ml-2"
              icon="info-outline"
              nbTooltip="Headline text shown in the notification summary item. Text is displayed if present, otherwise the Headline Text ID is looked at to display the text."
              i18n-nbTooltip
            ></nb-icon>
          </div>
        </div>
      </div>
      <br />

      <div class="row">
        <div class="col-4"><div i18n>Headline Text ID:</div></div>
        <div class="col-8">
          <ng-select
            placeholder="Headline Text ID"
            i18n-placeholder
            [(ngModel)]="content.headline_text_id"
            style="width: 90%"
            id="headline_text_id"
            name="headline_text_id"
            ngControl="categoryCtrl"
            #headline_text_id="ngModel"
            [addTag]="addTag"
          >
            <ng-option *ngFor="let drbID of drbIds.string" [value]="drbID">
              {{ drbID }}
            </ng-option>
          </ng-select>
        </div>
      </div>
      <br />

      <div class="row">
        <div class="col-4"><div i18n>Message Type:</div></div>
        <div class="col-8">
          <ng-select
            ngDefaultControl
            id="message_type"
            name="message_type"
            placeholder="Select Message Type"
            i18n-placeholder
            multiple="true"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="message_type"
            style="width: 90%"
            (add)="messageTypeAdd($event)"
            (remove)="messageTypeRemove($event)"
            (clear)="messageTypeClear()"
          >
            <ng-option *ngFor="let message of availableMessageTypes" [value]="message">{{
              message | replaceunderscore | titlecase
            }}</ng-option>
          </ng-select>
        </div>
      </div>
      <br />
      <!-- Dynamic MCA push notification fields -->
      <div class="row">
        <div class="col-4">
          <div i18n>Push Title String ID:</div>
        </div>
        <div class="col-8">
          <div class="d-flex align-items-center">
            <ng-select
              placeholder="Push Title String ID"
              i18n-placeholder
              [(ngModel)]="content.push_title_string_id"
              style="width: 90%"
              id="push_title_string_id"
              name="push_title_string_id"
              ngControl="categoryCtrl"
              #push_title_string_id="ngModel"
              [addTag]="addTag"
            >
              <ng-option *ngFor="let drbID of drbIds.string" [value]="drbID">
                {{ drbID }}
              </ng-option>
            </ng-select>
            <nb-icon
              class="ml-2"
              icon="info-outline"
              nbTooltip="Title shown in the push notification. Value is taken from DRB."
              i18n-nbTooltip
            ></nb-icon>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-4">
          <div i18n>Push String ID:</div>
        </div>
        <div class="col-8">
          <div class="d-flex align-items-center">
            <ng-select
              placeholder="Push String ID"
              i18n-placeholder
              [(ngModel)]="content.push_string_id"
              style="width: 90%"
              id="push_string_id"
              name="push_string_id"
              ngControl="categoryCtrl"
              #push_string_id="ngModel"
              [addTag]="addTag"
            >
              <ng-option *ngFor="let drbID of drbIds.string" [value]="drbID">
                {{ drbID }}
              </ng-option>
            </ng-select>
            <nb-icon
              class="ml-2"
              icon="info-outline"
              nbTooltip="Body shown in the push notification. Value is taken from DRB."
              i18n-nbTooltip
            ></nb-icon>
          </div>
        </div>
      </div>
      <br />
      <hr />

      <div class="row">
        <div class="col-4">
          <div i18n>Action Button</div>
        </div>
        <div class="col-8">
          <nb-checkbox
            ngDefaultControl
            (checkedChange)="actionButtonEvent($event)"
            [(ngModel)]="action_button_enabled"
            name="action_button_enabled"
            [ngModelOptions]="{ standalone: true }"
          ></nb-checkbox>
        </div>
      </div>
      <br />

      <div *ngIf="action_button_enabled">
        <div class="row">
          <div class="col-4">
            <div i18n>Button Text:</div>
          </div>
          <div class="col-8">
            <input
              nbInput
              placeholder="Text"
              i18n-placeholder
              [(ngModel)]="content.action_button[0].text"
              fullWidth
              style="width: 90%"
              id="action_button_text_id"
              name="action_button_text_id"
              ngControl="categoryCtrl"
            />
          </div>
        </div>
        <br />

        <div class="row">
          <div class="col-4">
            <div i18n>Button Text ID:</div>
          </div>
          <div class="col-8">
            <ng-select
              placeholder="Text ID"
              i18n-placeholder
              [(ngModel)]="content.action_button[0].text_id"
              style="width: 90%"
              id="action_button_text_id_id"
              name="action_button_text_id_id"
              ngControl="categoryCtrl"
              #action_button_text_id_id="ngModel"
              [addTag]="addTag"
            >
              <ng-option *ngFor="let drbID of drbIds.string" [value]="drbID">
                {{ drbID }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        <br />

        <div class="row">
          <div class="col-4">
            <div i18n>Destination URI:</div>
          </div>
          <div class="col-8">
            <input
              nbInput
              placeholder="Destination URI"
              i18n-placeholder
              [(ngModel)]="content.action_button[0].destination_uri"
              fullWidth
              style="width: 90%"
              id="action_button_destination_uri"
              name="action_button_destination_uri_id"
              ngControl="categoryCtrl"
            />
          </div>
        </div>
        <br />

        <div class="row">
          <div class="col-4">
            <div i18n>Destination URI ID:</div>
          </div>
          <div class="col-8">
            <ng-select
              placeholder="Destination URI ID"
              i18n-placeholder
              [(ngModel)]="content.action_button[0].destination_uri_id"
              [ngModelOptions]="{ standalone: true }"
              style="width: 90%"
              id="destination_uri_id"
              name="destination_uri_id"
              ngControl="categoryCtrl"
              #destination_uri_id="ngModel"
              [addTag]="addTag"
            >
              <ng-option *ngFor="let drbID of drbIds.link" [value]="drbID">
                {{ drbID }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        <br />

        <div class="row">
          <div class="col-4">
            <div i18n>Destination Type <span style="color: red">*</span>:</div>
          </div>
          <div class="col-8">
            <nb-select
              required
              placeholder="Select destination type"
              i18n-placeholder
              [(ngModel)]="content.action_button[0].destination_type"
              id="destination_type"
              name="destination_type"
              #destination_type="ngModel"
              fullWidth
              style="width: 90%"
            >
              <nb-option *ngFor="let destination_type of destinationTypes" [value]="destination_type.value">
                {{ destination_type.label | replaceunderscore | titlecase }}
              </nb-option>
            </nb-select>
            <div
              *ngIf="(destination_type?.touched || destination_type?.dirty) && destination_type?.errors?.required"
              class="error"
              i18n
            >
              Destination Type is a required field
            </div>
          </div>
        </div>
      </div>
      <br />
      <hr />

      <!-- Inside NG Template are fields from Payload Records [Array of paylod record] banner, MS, Contextual -->
      <ng-template ngFor let-i="index" let-payload [ngForOf]="payloadRecords">
        <ng-container *ngIf="payload.payload_record_type !== 'multi_page_contextual_message'">
        <nb-card accent="success" style="width: 600px; margin: auto">
          <nb-card-header>
            <div class="row">
              <div *ngIf="payload.payload_record_type !== 'banner'" class="col-auto mr-auto">
                {{ payload.payload_record_type.split('_').join(' ') | titlecase }}
              </div>
              <div *ngIf="payload.payload_record_type === 'banner'" class="col-auto mr-auto">
                {{ payload.payload_record_type | titlecase }}
              </div>
            </div>
          </nb-card-header>
          <nb-card-body>
            <div *ngIf="payload.payload_record_type === 'contextual_message'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Active Parent ID<span style="color: red">*</span>:</div>
                </div>
                <div class="col-8">
                  <div>
                    <ng-container *ngIf="prime; else legacy">
                      <ng-select
                        [(ngModel)]="content.active_parent_uri_id"
                        name="active_parent_uri_id"
                        id="active_parent_uri_id"
                        #active_parent_uri_id="ngModel"
                        placeholder="Select Prime URI"
                        i18n-placeholder
                        required
                        fullWidth
                        style="width: 90%"
                        [addTag]="addTag"
                      >
                        <ng-option *ngFor="let uri of primeUris" [value]="uri.value">
                          {{ uri.label }}
                        </ng-option>
                      </ng-select>
                      <div
                        *ngIf="
                          (active_parent_uri_id?.touched || active_parent_uri_id?.dirty) &&
                          active_parent_uri_id?.errors?.required
                        "
                        class="error"
                        i18n
                      >
                        Active parent uri id is a required field
                      </div>
                    </ng-container>
                  </div>

                  <!-- validation for prime -->

                  <ng-template #legacy>
                    <ng-select
                      [(ngModel)]="content.active_parent_uri_id"
                      name="active_parent_uri_id"
                      id="active_parent_uri_id"
                      #active_parent_uri_id="ngModel"
                      placeholder="Select Legacy URI"
                      i18n-placeholder
                      required
                      fullWidth
                      style="width: 90%"
                      [addTag]="addTag"
                    >
                      <ng-option *ngFor="let uri of legacyUris" [value]="uri.value">
                        {{ uri.label }}
                      </ng-option>
                    </ng-select>

                    <!-- validation for legacy -->
                    <div
                      *ngIf="
                        (active_parent_uri_id?.touched || active_parent_uri_id?.dirty) &&
                        active_parent_uri_id?.errors?.required
                      "
                      class="error"
                      i18n
                    >
                      Active parent uri id is a required field
                    </div>
                  </ng-template>
                </div>
              </div>
              <br />
            </div>

            <div *ngIf="payload.payload_record_type !== 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Action Display:</div>
                </div>
                <div class="col-8">
                  <ng-select
                    ngDefaultControl
                    id="action_display"
                    name="action_display"
                    placeholder="Select Action Display"
                    i18n-placeholder
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="payload.action_display"
                    fullWidth
                    style="width: 90%"
                    #action_display[i]="ngModel"
                    [clearable]="false"
                  >
                    <div *ngIf="payload.payload_record_type === 'contextual_message'">
                      <ng-option
                        *ngFor="let actionDisplay of actionDisplays | slice: 0 : 2"
                        [value]="actionDisplay.value"
                        >{{ actionDisplay.label | splitWordUppercase }}</ng-option
                      >
                    </div>
                    <div *ngIf="!['banner', 'personalized_offer'].includes(payload.payload_record_type)">
                      <ng-option
                        *ngFor="let actionDisplay of actionDisplays | slice: 2 : 3"
                        [value]="actionDisplay.value"
                        >{{ actionDisplay.label | splitWordUppercase }}</ng-option
                      >
                    </div>
                    <div *ngIf="payload.payload_record_type === 'personalized_offer'">
                      <ng-option
                        *ngFor="let actionDisplay of actionDisplays | slice: -1"
                        [value]="actionDisplay.value"
                        >{{ actionDisplay.label | splitWordUppercase }}</ng-option
                      >
                    </div>
                  </ng-select>
                </div>
              </div>
              <br />
            </div>

            <div *ngIf="payload.payload_record_type !== 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Content Text:</div>
                </div>
                <div class="col-8">
                  <textarea
                    nbInput
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="payload.content_text"
                    class="form-control form-control-sm"
                    type="text"
                    placeholder="Content Text"
                    i18n-placeholder
                    name="content_text"
                    #content_text[i]="ngModel"
                    fullWidth
                    style="width: 90%"
                  ></textarea>
                </div>
              </div>
              <br />
            </div>

            <div *ngIf="payload.payload_record_type !== 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Content Text ID:</div>
                </div>
                <div class="col-8">
                  <ng-select
                    placeholder="Content Text ID"
                    i18n-placeholder
                    [(ngModel)]="payload.content_text_id"
                    [ngModelOptions]="{ standalone: true }"
                    fullWidth
                    style="width: 90%"
                    id="content_text_id"
                    name="content_text_id"
                    ngControl="categoryCtrl"
                    #content_text_id[i]="ngModel"
                    [addTag]="addTag"
                  >
                    <ng-option *ngFor="let drbID of drbIds.string" [value]="drbID">
                      {{ drbID }}
                    </ng-option>
                  </ng-select>
                </div>
              </div>
              <br />
            </div>

            <div *ngIf="payload.payload_record_type !== 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Content Text Display Order:</div>
                </div>
                <div class="col-8">
                  <input
                    nbInput
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="payload.context_text_display_order"
                    class="form-control form-control-lg"
                    type="text"
                    placeholder="Context Text Display Order"
                    i18n-placeholder
                    name="context_text_display_order"
                    #context_text_display_order[i]="ngModel"
                    (keypress)="keyPressNumbers($event)"
                    fullWidth
                    style="width: 90%"
                  />
                </div>
              </div>
              <br />
              <br />
            </div>

            <div *ngIf="!['banner', 'personalized_offer'].includes(payload.payload_record_type)">
              <div class="row">
                <div class="col-4">
                  <div i18n>Video ID:</div>
                </div>
                <div class="col-8">
                  <ng-select
                    placeholder="Video ID"
                    i18n-placeholder
                    [(ngModel)]="payload.video_id"
                    [ngModelOptions]="{ standalone: true }"
                    fullWidth
                    style="width: 90%"
                    id="video_id"
                    name="video_id"
                    ngControl="categoryCtrl"
                    #video_id[i]="ngModel"
                    [addTag]="addTag"
                    (keypress)="keyPressNumbers($event)"
                  >
                    <ng-option *ngFor="let drbID of drbIds.video" [value]="drbID">
                      {{ drbID }}
                    </ng-option>
                  </ng-select>
                </div>
              </div>
              <br />
            </div>

            <div *ngIf="!['banner', 'personalized_offer'].includes(payload.payload_record_type)">
              <div class="row">
                <div class="col-4">
                  <div i18n>Video URL Display Order:</div>
                </div>
                <div class="col-8">
                  <input
                    nbInput
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="payload.video_url_display_order"
                    class="form-control form-control-lg"
                    type="text"
                    (keypress)="keyPressNumbers($event)"
                    placeholder="Video URL Display Order"
                    i18n-placeholder
                    name="video_url_display_order"
                    #video_url_display_order[i]="ngModel"
                    fullWidth
                    style="width: 90%"
                  />
                </div>
              </div>
              <br />
              <br />
            </div>

            <div *ngIf="payload.payload_record_type !== 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Content HTML:</div>
                </div>
                <div class="col-8">
                  <textarea
                    nbInput
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="payload.content_html"
                    class="form-control form-control-sm"
                    type="rich_text"
                    placeholder="Content HTML"
                    i18n-placeholder
                    name="content_html"
                    #content_html[i]="ngModel"
                    fullWidth
                    style="width: 90%"
                  ></textarea>
                </div>
              </div>
              <br />
            </div>

            <div *ngIf="payload.payload_record_type !== 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Content HTML ID:</div>
                </div>
                <div class="col-8">
                  <ng-select
                    placeholder="Content HTML ID"
                    i18n-placeholder
                    [(ngModel)]="payload.content_html_id"
                    [ngModelOptions]="{ standalone: true }"
                    fullWidth
                    style="width: 90%"
                    id="content_html_id"
                    name="content_html_id"
                    ngControl="categoryCtrl"
                    #content_html_id[i]="ngModel"
                    [addTag]="addTag"
                  >
                    <ng-option *ngFor="let drbID of drbIds.string" [value]="drbID">
                      {{ drbID }}
                    </ng-option>
                  </ng-select>
                </div>
              </div>
              <br />
            </div>

            <div *ngIf="payload.payload_record_type !== 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Content HTML Display Order:</div>
                </div>
                <div class="col-8">
                  <input
                    nbInput
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="payload.content_html_display_order"
                    class="form-control form-control-lg"
                    type="text"
                    placeholder="Content HTML Display Order"
                    i18n-placeholder
                    name="content_html_display_order"
                    #content_html_display_order[i]="ngModel"
                    fullWidth
                    style="width: 90%"
                  />
                </div>
              </div>
              <br />
              <br />
            </div>

            <div *ngIf="payload.payload_record_type !== 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Image ID:</div>
                </div>
                <div class="col-8">
                  <ng-select
                    placeholder="Image ID"
                    i18n-placeholder
                    [(ngModel)]="payload.image_id"
                    [ngModelOptions]="{ standalone: true }"
                    fullWidth
                    style="width: 90%"
                    id="image_id"
                    name="image_id"
                    ngControl="categoryCtrl"
                    #image_id[i]="ngModel"
                    [addTag]="addTag"
                  >
                    <ng-option *ngFor="let drbID of drbIds.image" [value]="drbID">
                      {{ drbID }}
                    </ng-option>
                  </ng-select>
                </div>
              </div>
              <br />
            </div>

            <div *ngIf="payload.payload_record_type !== 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Image URL:</div>
                </div>
                <div class="col-8">
                  <input
                    nbInput
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="payload.image_url"
                    class="form-control form-control-lg"
                    type="text"
                    placeholder="Image URL"
                    i18n-placeholder
                    name="image_url"
                    #image_url[i]="ngModel"
                    fullWidth
                    style="width: 90%"
                  />
                </div>
              </div>
              <br />
            </div>

            <div *ngIf="payload.payload_record_type !== 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Image Display Order:</div>
                </div>
                <div class="col-8">
                  <input
                    nbInput
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="payload.image_display_order"
                    class="form-control form-control-lg"
                    type="text"
                    placeholder="Image Display Order"
                    i18n-placeholder
                    name="image_display_order"
                    #image_display_order[i]="ngModel"
                    fullWidth
                    style="width: 90%"
                  />
                </div>
              </div>
              <br />
              <br />
            </div>

            <div *ngIf="payload.payload_record_type !== 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Webview URL:</div>
                </div>
                <div class="col-8">
                  <div class="d-flex align-items-center">
                    <input
                      nbInput
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="payload.webview_url"
                      class="form-control form-control-lg"
                      type="text"
                      placeholder="Webview URL"
                      i18n-placeholder
                      name="webview_url"
                      #webview_url[i]="ngModel"
                      fullWidth
                      style="width: 90%"
                    />
                    <nb-icon
                      class="ml-2"
                      icon="info-outline"
                      nbTooltip="The URL that will be used to populate a web view displayed when the message is opened. The content text field can be used to supply a heading to the web view container."
                      i18n-nbTooltip
                    ></nb-icon>
                  </div>
                </div>
              </div>
              <br />
            </div>

            <div *ngIf="payload.payload_record_type !== 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Webview URL ID:</div>
                </div>
                <div class="col-8">
                  <ng-select
                    placeholder="Webview URL ID"
                    i18n-placeholder
                    [(ngModel)]="payload.webview_url_id"
                    [ngModelOptions]="{ standalone: true }"
                    fullWidth
                    style="width: 90%"
                    id="webview_url_id"
                    name="webview_url_id"
                    ngControl="categoryCtrl"
                    #webview_url_id[i]="ngModel"
                    [addTag]="addTag"
                  >
                    <ng-option *ngFor="let drbID of drbIds.link" [value]="drbID">
                      {{ drbID }}
                    </ng-option>
                  </ng-select>
                </div>
              </div>
              <br />
            </div>

            <div *ngIf="payload.payload_record_type !== 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Webview URL Display Order:</div>
                </div>
                <div class="col-8">
                  <input
                    nbInput
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="payload.webview_url_display_order"
                    class="form-control form-control-lg"
                    type="text"
                    placeholder="Webview URL Display Order"
                    i18n-placeholder
                    name="webview_url_display_order"
                    #webview_url_display_order[i]="ngModel"
                    fullWidth
                    style="width: 90%"
                  />
                </div>
              </div>
              <br />
              <br />
            </div>

            <div *ngIf="payload.payload_record_type !== 'banner'">
              <div [hidden]="!isScriptedNavigationEnabled">
                <div class="row">
                  <div class="col-4">
                    <div i18n>Script ID:</div>
                  </div>
                  <div class="col-8">
                    <div class="d-flex align-items-center">
                      <ng-select
                        placeholder="Script ID"
                        i18n-placeholder
                        [(ngModel)]="payload.script_id"
                        [ngModelOptions]="{ standalone: true }"
                        fullWidth
                        style="width: 90%"
                        id="scripted_navigation_id"
                        name="scripted_navigation_id"
                        ngControl="categoryCtrl"
                        #scripted_navigation_id[i]="ngModel"
                        [addTag]="addTag"
                      >
                        <ng-option *ngFor="let drbID of drbIds.file" [value]="drbID">
                          {{ drbID }}
                        </ng-option>
                      </ng-select>
                      <nb-icon
                        class="ml-2"
                        icon="info-outline"
                        nbTooltip="This references a scripted navigation flow, which is stored within the DRB. Any value for this field is only valid when action type is scripted navigation. Moreover, all other content fields will be ignored, and the display order of this field will be 0."
                        i18n-nbTooltip
                      ></nb-icon>
                    </div>
                  </div>
                </div>
                <br />
              </div>
            </div>

            <div *ngIf="payload.payload_record_type !== 'banner'">
              <div [hidden]="!isScriptedNavigationEnabled">
                <div class="row">
                  <div class="col-4"><div i18n>Script ID Display Order:</div></div>
                  <div class="col-8">
                    <input
                      nbInput
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="payload.script_id_display_order"
                      class="form-control form-control-lg"
                      type="text"
                      placeholder="Script ID Display Order"
                      i18n-placeholder
                      name="script_id_display_order"
                      #scripted_navigation_id[i]="ngModel"
                      fullWidth
                      style="width: 90%"
                    />
                  </div>
                </div>
                <br />
              </div>
            </div>

            <!-- Banner specific -->
            <div *ngIf="payload.payload_record_type === 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Banner ID:</div>
                </div>
                <div class="col-8">
                  <input
                    nbInput
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="payload.banner_id"
                    class="form-control form-control-lg"
                    type="text"
                    placeholder="Banner ID"
                    i18n-placeholder
                    name="banner_id"
                    #banner_id[i]="ngModel"
                    fullWidth
                    style="width: 90%"
                  />
                </div>
              </div>
              <br />
            </div>

            <div *ngIf="payload.payload_record_type === 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Banner Text:</div>
                </div>
                <div class="col-8">
                  <input
                    nbInput
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="payload.banner_text"
                    class="form-control form-control-lg"
                    type="text"
                    placeholder="Banner Text"
                    i18n-placeholder
                    name="banner_text"
                    #banner_text[i]="ngModel"
                    fullWidth
                    style="width: 90%"
                  />
                </div>
              </div>
              <br />
            </div>

            <div *ngIf="payload.payload_record_type === 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Disclaimers Text:</div>
                </div>
                <div class="col-8">
                  <div class="d-flex align-items-center">
                    <input
                      nbInput
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="payload.disclaimers_text"
                      class="form-control form-control-lg"
                      type="text"
                      placeholder="Disclaimers Text"
                      i18n-placeholder
                      name="disclaimers_text"
                      #disclaimers_text[i]="ngModel"
                      fullWidth
                      style="width: 90%"
                    />
                    <nb-icon
                      class="ml-2"
                      icon="info-outline"
                      nbTooltip="Disclaimer text shown at the end of the content body in a smaller font."
                      i18n-nbTooltip
                    ></nb-icon>
                  </div>
                </div>
              </div>
              <br />
            </div>

            <div *ngIf="payload.payload_record_type === 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Product URL:</div>
                </div>
                <div class="col-8">
                  <div class="d-flex align-items-center">
                    <input
                      nbInput
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="payload.product_url"
                      class="form-control form-control-lg"
                      type="text"
                      placeholder="Product URL"
                      i18n-placeholder
                      name="product_url"
                      #product_url[i]="ngModel"
                      fullWidth
                      style="width: 90%"
                    />
                    <nb-icon
                      class="ml-2"
                      icon="info-outline"
                      nbTooltip="Store URL of the product. Used in banners."
                      i18n-nbTooltip
                    ></nb-icon>
                  </div>
                </div>
              </div>
              <br />
            </div>

            <div *ngIf="payload.payload_record_type === 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Banner Image ID:</div>
                </div>
                <div class="col-8">
                  <ng-select
                    placeholder="Banner Image ID"
                    i18n-placeholder
                    [(ngModel)]="payload.banner_image_id"
                    [ngModelOptions]="{ standalone: true }"
                    fullWidth
                    style="width: 90%"
                    id="banner_image_id"
                    name="banner_image_id"
                    ngControl="categoryCtrl"
                    #banner_image_id[i]="ngModel"
                    [addTag]="addTag"
                  >
                    <ng-option *ngFor="let drbID of drbIds.image" [value]="drbID">
                      {{ drbID }}
                    </ng-option>
                  </ng-select>
                </div>
              </div>
              <br />
            </div>

            <div *ngIf="payload.payload_record_type === 'banner'">
              <div class="row">
                <div class="col-4">
                  <div i18n>Source Code:</div>
                </div>
                <div class="col-8">
                  <div class="d-flex align-items-center">
                    <input
                      nbInput
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="payload.source_code"
                      class="form-control form-control-lg"
                      type="text"
                      placeholder="Source Code"
                      i18n-placeholder
                      name="source_code"
                      #source_code[i]="ngModel"
                      fullWidth
                      style="width: 90%"
                    />
                    <nb-icon
                      class="ml-2"
                      icon="info-outline"
                      nbTooltip="Promotion code with the native Product Personalization Feed experience that will be applied at checkout."
                      i18n-nbTooltip
                    ></nb-icon>
                  </div>
                </div>
              </div>
              <br />
            </div>
            <!--  -->
          </nb-card-body>
          <nb-card-footer
            *ngIf="
              payload.payload_record_type &&
              ['contextual_message', 'personalized_offer'].includes(payload.payload_record_type)
            "
          >
            <div class="d-flex justify-content-end">
              <button
                type="button"
                nbButton
                size="small"
                status="info"
                [disabled]="!marketing.version || !marketing_translations.version"
                (click)="previewContent()"
                [nbSpinner]="!marketing.version || !marketing_translations.version"
                nbSpinnerStatus="info"
                i18n
              >
                Preview Content
              </button>
            </div>
          </nb-card-footer>
        </nb-card>
        <br />
        <hr />
        </ng-container>
      </ng-template>

      <!-- Multi Page Contextual Message — one tab per page, minimum 2 pages -->
      <ng-container *ngIf="hasMultiPageRecords()">
        <nb-card accent="success" style="width: 600px; margin: auto">
          <nb-card-header>
            <div class="row">
              <div class="col-auto mr-auto" i18n>Multi Page Contextual Message</div>
            </div>
          </nb-card-header>
          <nb-card-body>
            <!-- Shared Active Parent URI (applies to all pages, Prime only) -->
            <div class="row">
              <div class="col-4">
                <div i18n>Active Parent ID<span style="color: red">*</span>:</div>
              </div>
              <div class="col-8">
                <ng-select
                  [(ngModel)]="content.active_parent_uri_id"
                  [ngModelOptions]="{ standalone: true }"
                  name="mp_active_parent_uri_id"
                  id="mp_active_parent_uri_id"
                  #mp_active_parent_uri_id="ngModel"
                  placeholder="Select Prime URI"
                  i18n-placeholder
                  required
                  fullWidth
                  style="width: 90%"
                  [addTag]="addTag"
                >
                  <ng-option *ngFor="let uri of primeUris" [value]="uri.value">
                    {{ uri.label }}
                  </ng-option>
                </ng-select>
                <div
                  *ngIf="(mp_active_parent_uri_id?.touched || mp_active_parent_uri_id?.dirty) && mp_active_parent_uri_id?.errors?.required"
                  class="error"
                  i18n
                >
                  Active parent uri id is a required field
                </div>
              </div>
            </div>
            <br />

            <!-- Firefox-style tab controls: × on each tab, + at end of tab bar -->
            <div class="mp-tabset-wrapper">
              <nb-tabset (changeTab)="onMultiPageTabChange($event)">
                <nb-tab
                  *ngFor="let item of multiPageRecordsWithIndex; let tabIdx = index; trackBy: trackByIndex"
                >
                  <ng-template nbTabTitle>
                    <span>Page {{ tabIdx + 1 }}</span>
                    <button
                      type="button"
                      class="mp-tab-close"
                      [disabled]="multiPageRecordsWithIndex.length <= 2"
                      (click)="$event.preventDefault(); $event.stopPropagation(); removeMultiPageRecordByTabIdx(tabIdx)"
                      [title]="'Close page ' + (tabIdx + 1)"
                    >×</button>
                  </ng-template>
                  <div class="row">
                    <div class="col-4"><div i18n>Action Display:</div></div>
                    <div class="col-8">
                      <ng-select
                        ngDefaultControl
                        [id]="'mp_action_display_' + tabIdx"
                        [name]="'mp_action_display_' + tabIdx"
                        placeholder="Select Action Display"
                        i18n-placeholder
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="item.payload.action_display"
                        fullWidth
                        style="width: 90%"
                        [clearable]="false"
                      >
                        <ng-option *ngFor="let actionDisplay of actionDisplays | slice: 0 : 2" [value]="actionDisplay.value">
                          {{ actionDisplay.label | splitWordUppercase }}
                        </ng-option>
                      </ng-select>
                    </div>
                  </div>
                  <br />

                  <div class="row">
                    <div class="col-4"><div i18n>Content Text:</div></div>
                    <div class="col-8">
                      <textarea
                        nbInput
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="item.payload.content_text"
                        class="form-control form-control-sm"
                        type="text"
                        placeholder="Content Text"
                        i18n-placeholder
                        [name]="'mp_content_text_' + tabIdx"
                        fullWidth
                        style="width: 90%"
                      ></textarea>
                    </div>
                  </div>
                  <br />

                  <div class="row">
                    <div class="col-4"><div i18n>Content Text ID:</div></div>
                    <div class="col-8">
                      <ng-select
                        placeholder="Content Text ID"
                        i18n-placeholder
                        [(ngModel)]="item.payload.content_text_id"
                        [ngModelOptions]="{ standalone: true }"
                        fullWidth
                        style="width: 90%"
                        [id]="'mp_content_text_id_' + tabIdx"
                        [name]="'mp_content_text_id_' + tabIdx"
                        [addTag]="addTag"
                      >
                        <ng-option *ngFor="let drbID of drbIds.string" [value]="drbID">{{ drbID }}</ng-option>
                      </ng-select>
                    </div>
                  </div>
                  <br />

                  <div class="row">
                    <div class="col-4"><div i18n>Content Text Display Order:</div></div>
                    <div class="col-8">
                      <input
                        nbInput
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="item.payload.context_text_display_order"
                        class="form-control form-control-lg"
                        type="text"
                        placeholder="Context Text Display Order"
                        i18n-placeholder
                        [name]="'mp_context_text_display_order_' + tabIdx"
                        (keypress)="keyPressNumbers($event)"
                        fullWidth
                        style="width: 90%"
                      />
                    </div>
                  </div>
                  <br /><br />

                  <div class="row">
                    <div class="col-4"><div i18n>Content HTML:</div></div>
                    <div class="col-8">
                      <textarea
                        nbInput
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="item.payload.content_html"
                        class="form-control form-control-sm"
                        type="rich_text"
                        placeholder="Content HTML"
                        i18n-placeholder
                        [name]="'mp_content_html_' + tabIdx"
                        fullWidth
                        style="width: 90%"
                      ></textarea>
                    </div>
                  </div>
                  <br />

                  <div class="row">
                    <div class="col-4"><div i18n>Content HTML ID:</div></div>
                    <div class="col-8">
                      <ng-select
                        placeholder="Content HTML ID"
                        i18n-placeholder
                        [(ngModel)]="item.payload.content_html_id"
                        [ngModelOptions]="{ standalone: true }"
                        fullWidth
                        style="width: 90%"
                        [id]="'mp_content_html_id_' + tabIdx"
                        [name]="'mp_content_html_id_' + tabIdx"
                        [addTag]="addTag"
                      >
                        <ng-option *ngFor="let drbID of drbIds.string" [value]="drbID">{{ drbID }}</ng-option>
                      </ng-select>
                    </div>
                  </div>
                  <br />

                  <div class="row">
                    <div class="col-4"><div i18n>Content HTML Display Order:</div></div>
                    <div class="col-8">
                      <input
                        nbInput
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="item.payload.content_html_display_order"
                        class="form-control form-control-lg"
                        type="text"
                        placeholder="Content HTML Display Order"
                        i18n-placeholder
                        [name]="'mp_content_html_display_order_' + tabIdx"
                        fullWidth
                        style="width: 90%"
                      />
                    </div>
                  </div>
                  <br /><br />

                  <div class="row">
                    <div class="col-4"><div i18n>Image ID:</div></div>
                    <div class="col-8">
                      <ng-select
                        placeholder="Image ID"
                        i18n-placeholder
                        [(ngModel)]="item.payload.image_id"
                        [ngModelOptions]="{ standalone: true }"
                        fullWidth
                        style="width: 90%"
                        [id]="'mp_image_id_' + tabIdx"
                        [name]="'mp_image_id_' + tabIdx"
                        [addTag]="addTag"
                      >
                        <ng-option *ngFor="let drbID of drbIds.image" [value]="drbID">{{ drbID }}</ng-option>
                      </ng-select>
                    </div>
                  </div>
                  <br />

                  <div class="row">
                    <div class="col-4"><div i18n>Image URL:</div></div>
                    <div class="col-8">
                      <input
                        nbInput
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="item.payload.image_url"
                        class="form-control form-control-lg"
                        type="text"
                        placeholder="Image URL"
                        i18n-placeholder
                        [name]="'mp_image_url_' + tabIdx"
                        fullWidth
                        style="width: 90%"
                      />
                    </div>
                  </div>
                  <br />

                  <div class="row">
                    <div class="col-4"><div i18n>Image Display Order:</div></div>
                    <div class="col-8">
                      <input
                        nbInput
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="item.payload.image_display_order"
                        class="form-control form-control-lg"
                        type="text"
                        placeholder="Image Display Order"
                        i18n-placeholder
                        [name]="'mp_image_display_order_' + tabIdx"
                        fullWidth
                        style="width: 90%"
                      />
                    </div>
                  </div>
                  <br />
                </nb-tab>
              </nb-tabset>
              <button
                type="button"
                class="mp-add-tab-btn"
                (click)="addMultiPageRecord()"
                title="Add page"
                i18n-title
              >+</button>
            </div>
          </nb-card-body>
        </nb-card>
        <br />
        <hr />
      </ng-container>
    </form>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button
        nbButton
        class="ml-3"
        status="success"
        [disabled]="!contentForm.valid || !shouldButtonEnabled()"
        (click)="save()"
        i18n
      >
        Save
      </button>
    </div>
  </nb-card-footer>
</nb-card>
